import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TaxonomyCodeIcon from "../../../assets/images/svg-icons-material-io/link_FILL0_wght400_GRAD0_opsz48.svg";
import MonitorIcon from "../../../assets/images/svg-icons-material-io/screenshot_monitor_FILL0_wght400_GRAD0_opsz48.svg";
import BulkUploadTemplate from "../../../assets/images/OrgbulkUploadimg.JPG";
import { Link } from "react-router-dom";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";
import fileDownload from "js-file-download";

const obj = {
  VendorId: 0,
  OrganizationId: 0,
  OrganizationName: "",
  UserSubmitFile: "",
};
const UploadOrgForm = () => {
  const navigate = useNavigate();
  const {
    userToken,
    sharedObject,
    SetSharedObject,
    userRole,
    customerObj,
    userSession,
  } = useUserStore((state) => ({
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    userRole: state.userRole,
    customerObj: state.customerObj,
    userSession: state.userSession,
  }));
  const [processing, SetProcessing] = useState(false);
  const [submitFlag, SetSubmitFlag] = useState(false);
  const [errFlag, SetErrFlag] = useState(false);
  const [successFlag, SetSuccessFlag] = useState(false);
  const [answers, setAnswers] = useState(obj);
  const [orgObj, SetOrgObj] = useState([]);
  const [custObject, SetCustObject] = useState([]);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [customerErrorFlag, setCustomerErrorFlag] = useState(false);
  const vend = () => {
    const temp = [];
    let flag = false;
      let id = 0;
      let custObj = sharedObject.CustomerPermissionsObj;
     
    for (let el of sharedObject.vendorsObj) {
      el.show = true;
      temp.push(el);
      //if (
      //  userRole != "SES ADMINISTRATOR" &&
      //  el.id === parseInt(userSession.vendor_id)
      //) {
      //  let vl = el.id;
      //  setAnswer("VendorId", vl);
      //  id = vl;
      //  flag = true;
      //}
      } 
      if (custObj && Object.keys(custObj).length > 0 && custObj.constructor === Object) {
          setAnswer("VendorId", custObj.id);
          CustomerIdSet(custObj.id);
      }
    SetCustObject(temp);
    //if (flag && id !== 0) {
    //  CustomerIdSet(id);
    //}
  };
  useEffect(() => {
    if (userRole !== "SES ADMINISTRATOR") {
      const temp = [];
      for (let el of sharedObject.getOrgsObj) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
    } else {
      vend();
    }
    SetSharedObject("specialties", {});
    SetSubmitFlag(false);
    setCustomerErrorFlag(false);
  }, []);

  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const CustomerIdSet = async (el) => {
    if (el === "") {
      SetOrgObj([]);
      return;
    }
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObj?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObj(tmp);
  };

  const downTemplate = async (url) => {
    SetProcessing(true);
    const res = await CallAPI(url, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let fileName = "OrganizationUploadTemplate.csv";
      fileDownload(res.data, fileName);
      SetProcessing(false);
    }
  };
  const UploadFile = async () => {
    setCustomerErrorFlag(false);
    SetSuccessFlag(false);
    SetSubmitFlag(true);
    if (!answers?.UserSubmitFile) {
      document.getElementById("UserSubmitFile").scrollIntoView();
      document.getElementById("UserSubmitFile").focus();
      return;
    } else if (!answers.OrganizationId) {
      document.getElementById("OrganizationId").scrollIntoView();
      document.getElementById("OrganizationId").focus();
      return;
    }
    SetProcessing(true);
    let url =
      "/organization/OrganizationUpload?OrganizatonId=" +
      answers.OrganizationId;
    const fileInput = document.querySelector('input[type="file"]');
    const file = fileInput.files[0];
    const bodyFormData = new FormData();
    bodyFormData.append("file", file, file.name);
    const res = await CallAPI(url, bodyFormData, "post", userToken, true);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = JSON.parse(res.data.data);
      SetSharedObject("UploadObj", dt);
      SetSharedObject("UploadFlag", "org");
      SetProcessing(false);
      navigate("/upload-results");
    } else if (res.status === "VALIDATIONERROR") {
      let msg = JSON.parse(res.data);
      let str = "";
      if (typeof msg === "string") {
        str = msg;
      } else {
        str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
      }
      SetErrMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "";
      if (typeof msg === "string") {
        str = msg;
      } else {
        str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
      }
      SetErrMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
  };

  const triggerValidation = (el) => {
    var regex = new RegExp("(.*?).(csv)$");
    if (!regex.test(el.target.value.toLowerCase())) {
      SetErrFlag(true);
    } else {
      setAnswer("UserSubmitFile", el);
      SetErrFlag(false);
    }
  };
  const getDomain = (url) => {
    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }
    return url;
  };
  const openImg = () => {
    let url = getDomain(window.location.hostname);
    if (url === "localhost") {
      window.open(BulkUploadTemplate);
    } else {
      window.open(BulkUploadTemplate);
    }
  };
  return (
    <div className="UploadOrgForm">
      <form className="sp-pad1">
        {/*Left Panel*/}
        <div className="left-panel-s1">
          {userRole !== "SES ADMINISTRATOR" ? null : (
            <div className="field-wrapper">
              <label for="customer">Customer</label>
              <span className="filter-container dg-clr">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  onChange={(el) => {
                    filterVendors(el.target.value);
                  }}
                />
              </span>
              <select
                className="form-control"
                size="5"
                id="VendorId"
                name="VendorId"
                onChange={(el) => {
                  CustomerIdSet(el.target.value);
                  setAnswer("VendorId", parseInt(el.target.value));
                }}
                value={answers?.VendorId}
              >
                <option value={0}>Select Customer</option>
                {custObject?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {submitFlag && answers?.VendorId === 0 ? (
                <div className="alert alert-danger">Customer is required.</div>
              ) : null}
            </div>
          )}
          {/*Organization - show only for org admins*/}
          <div className="field-wrapper">
            <label for="Org"> Parent Organization </label>
            {/*<i className="bi bi-asterisk rd-clr" aria-labelledby="Required" alt="asterik"></i>*/}
            <span className="filter-container dg-clr">
              <input
                className="form-control filter-sm"
                type="search"
                placeholder="Filter"
                onChange={(el) => filterOrganiations(el.target.value)}
              />
            </span>
            {orgObj.length > 0 ? (
              <select
                className="form-control"
                size="4"
                name="OrganizationId"
                id="OrganizationId"
                onChange={(el) => {
                  setAnswer("OrganizationId", parseInt(el.target.value));
                }}
                value={answers?.OrganizationId}
              >
                <option value={0}>Select Organization</option>
                {orgObj?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={`${el.id}`}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
            ) : (
              <div className="watermark-wrapper">No Results</div>
            )}
            {answers?.OrganizationId === 0 && submitFlag ? (
              <div className="alert alert-danger">
                Organization is required.
              </div>
            ) : null}
          </div>
          {/*Select CSV File*/}
          <div className="field-wrapper">
            <label for="FristName">Select CSV file</label>
            <div className="form-group">
              <input
                type="file"
                className="form-control-file  cblu-clr "
                id="UserSubmitFile"
                onChange={(el) => {
                  triggerValidation(el);
                }}
                //value={answers?.UserSubmitFile}
              />
              {answers?.UserSubmitFile === "" && submitFlag ? (
                <div className="alert alert-danger">CSV file is required.</div>
              ) : null}
            </div>
            {errFlag ? (
              <div className="alert alert-danger">
                The file you are trying to upload is not a CSV file. Please try
                again using a proper file type with a .csv file extension. You
                can also download our template and view our sample below.
              </div>
            ) : null}
            <aside className="filelist-items">
              The MS Excel spreadsheet must be saved as a CSV format that
              contains a .csv extension and rename the file if you intend to
              upload it again.
            </aside>
          </div>
          {errCreateMsg ? (
            <div
              className={`alert alert-danger`}
              dangerouslySetInnerHTML={{ __html: errMsg }}
            />
          ) : null}

          {/*Processing Spinner*/}
          {processing ? (
            //<div className="spinner-wrapper">
            //  <div className="reverse-spinner spinner1"></div>
            //  <div className="spacer-inline spacer-margin2">Processing...</div>
            //</div>
            <div className="loading"></div>
          ) : null}
          {/*Upload Action*/}
          <div className="button-register-container text-size4">
            {!successFlag ? (
              <button
                type="button"
                className="btn btn-success"
                disabled={errFlag}
                onClick={(e) => UploadFile()}
              >
                Upload
              </button>
            ) : (
              ""
            )}
            <Link
              type="button"
              className="btn btn-outline-secondary spacer-margin9 "
              to="/Organizations"
            >
              {successFlag ? "Close" : "Cancel"}
            </Link>
          </div>

          {/*Templates*/}
          <div className="box-template">
            <a
              href="javascript:void(0);"
              onClick={(el) =>
                downTemplate(
                  "/organization/DownloadCsvTemplate?csv=OrganizationUploadTemplate"
                )
              }
              className="btn btn-primary box-containers box-sentmsg"
            >
              <div className="box-icon">
                <i className="bi bi-download"></i>
              </div>
              <div className="box-bottom">
                <div className="title">CSV File Template</div>
              </div>
            </a>
            <a
              href="https://www.nucc.org/index.php?option=com_content&view=article&id=107&Itemid=132"
              target="_blank"
              className="btn btn-primary box-containers box-status"
              rel="noreferrer"
            >
              <div className="box-icon">
                <img
                  src={TaxonomyCodeIcon}
                  className="filter-white"
                  alt="Taxonomy Codes Icon"
                />
              </div>
              <div className="box-bottom">
                <div className="title">NUCC Taxonomy Codes</div>
              </div>
            </a>
            <Link
              //to={BulkUploadTemplate}
              onClick={openImg}
              target="_blank"
              className="btn btn-primary box-containers box-reports"
              alt="Sample CSV Template Screenshot"
            >
              <div className="box-icon">
                <img
                  src={MonitorIcon}
                  className="filter-white"
                  alt="Monitor Screen Icon"
                />
              </div>
              <div className="box-bottom">
                <div className="title">
                  Sample <br />
                  CSV File Screenshots
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/*Right Panel*/}
        <div className="right-panel-s1">
          {/*Requirement Rules*/}
          <div className="field-wrapper label-hd-divider">Requirements</div>
          <div className="field-wrapper">
            <div className="text-reg spacer-margin7">
              The following list of items are required and must be included in
              your file.
            </div>
            <ul className="filelist-items">
              <li>
                <span className="ft-wt blk-clr">Organization Name</span>
              </li>
              <li>
                <span className="ft-wt blk-clr">External ID:</span> Organization
                ID
                <ul>
                  <li>Must be unique for the same customer</li>
                </ul>
              </li>
              <li>
                <span className="ft-wt blk-clr">
                  Organization Type (OrgKind):
                </span>
                <ul>
                  <li>Health_System</li>
                  <li>Long Term Care Provider enter LTCP</li>
                  <li>Health Care Organization enter HCO</li>
                  <li>Health Care Provider enter HCP</li>
                  <li>Pharmacy</li>
                  <li>Department</li>
                  <li>Non_HealthcareProvider</li>
                  <li>Practice</li>
                  <li>Health Information Exchange enter HIE</li>
                  <li>Payer</li>
                  <li>Laboratory enter Lab</li>
                  <li>Hospital</li>
                </ul>
              </li>
              <li>
                <span className="ft-wt blk-clr">Address 1:</span> 100 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">City:</span> 50 character limit
              </li>
              <li>
                <span className="ft-wt blk-clr">State:</span> State Abbreviation
                - 2 character limit - Uppercase Only
              </li>
              <li>
                <span className="ft-wt blk-clr">Zip Code:</span> 5 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">Phone Number:</span> Use
                xxxxxxxxxx format
              </li>
            </ul>
          </div>

          {/*Optional Rules*/}
          <div className="field-wrapper label-hd-divider">Optional</div>
          <div className="field-wrapper">
            <div className="text-reg spacer-margin7">
              The following list of items are your options to include in your
              file.
            </div>
            <ul className="filelist-items">
              <li>
                <span className="ft-wt blk-clr">Organization Description</span>
              </li>
              <li>
                <span className="ft-wt blk-clr">Keywords:</span> Provide a
                collection of important but yet easy to search words
              </li>
              <li>
                <span className="ft-wt blk-clr">NUCC Taxonomy:</span> Input the
                code found in the current version of the National Uniform Claim
                Committee Health Care Provider Taxonomy Code Set.
              </li>
              <li>
                <span className="ft-wt blk-clr">
                  NPI (National Provider ID):
                </span>
                Must be a 10 digit number (Use xxxxxxxxxx format)
              </li>
              <li>
                <span className="ft-wt blk-clr">Address 2:</span> 100 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">Fax Number:</span> Use
                xxxxxxxxxx format
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UploadOrgForm;
